import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/cashes`, {params: {...filters}})
  },

  indexCmc7(cmc7) {
    return Http.get(`/cmc7_cashes`, {params: {cmc7}})
  },

  show(id) {
    return Http.get(`/cashes/${id}`);
  },

}
